<template>
  <aceHotel :revinate_token="revinate_token" :template="template" :portal="portal" :connection_data="connection_data" @emitRegistrationMethodData="handleEmit" />
</template>
<script>
import aceHotel from '@/components/custom/aceHotel/index'
export default {
  name: 'custom_template_ace_new_orleans',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { aceHotel },
  data(){
    return{
      revinate_token: 'ad214a1a-75c4-47e2-a022-0b1a75e7e19b'
    }
  },
  methods: {
    handleEmit:function(data){
      this.$emit('emitRegistrationMethodData', data);
    }
  }
}
</script>
<style>
</style>